<template>
  <div class="Live">
    <iframe id="frame" frameborder="0"></iframe>
    <!-- 桌面端内且支持安全锁的版本，由于本页面无解锁入口，故需要提供后退按钮 -->
    <el-button
      v-if="$store.state.desktop && $store.state.desktop.deviceInfo"
      class="goBack"
      size="small"
      type="text"
      @click="goBackHandle"
    >
      &lt; 返回
    </el-button>
  </div>
</template>
<script>
export default {
  name: 'Live',
  data() {
    return {
      course_id: this.$route.query.course_id,
      period_id: this.$route.query.period_id,
      bjy_period_id: this.$route.query.bjy_period_id,
      type: this.$route.query.type,
      last_time: 0,
      meeting_id: this.$route.query.meeting_id,
    };
  },
  methods: {
    handle(url) {
      document.getElementById('frame').src = url;
    },
    async onMessgae(event) {
      if (!event.data.totalTime || !this.bjy_period_id) {
        return;
      }
      if (this.last_time == event.data.currentTime) {
        return;
      }
      this.last_time = event.data.currentTime;
      await this.$http.post('/api/app/course/playBack', {
        course_basis_id: parseInt(this.course_id),
        course_periods_id: parseInt(this.bjy_period_id),
        total_time: parseInt(event.data.totalTime),
        last_time: parseInt(event.data.currentTime),
        current_time: 120,
      });
    },
    async play() {
      let course_type = this.$route.query.course_type;

      let liveData;
      if (course_type == 1) {
        liveData = await this.$http.get(
          '/api/app/oto/getLiveRoomCode/' + this.course_id + '/0',
          {},
          {
            onError: () => {
              this.$router.push({ name: 'Home' });
            },
          },
        );
      } else if (
        course_type == 2 ||
        course_type == 3 ||
        course_type == 4 ||
        course_type == 15 ||
        course_type == 16
      ) {
        let data = await this.$http.get(
          '/api/app/getPcRoomCode/course_id=' + this.course_id + '/chapter_id=' + this.period_id,
          {
            type: this.type,
            arrange_id: this.$route.query.arrange_id,
          },
          {
            onError: () => {
              this.$router.push({ name: 'Home' });
            },
          },
        );
        liveData = data.chapterInfo;
      } else if (course_type == 'meeting') {
        //班会
        let params = {};
        params.type = this.type;
        params.meeting_id = this.meeting_id;
        let data = await this.$http.get(
          '/api/app/getPcRoomCode/course_id=' + this.course_id + '/chapter_id=' + this.period_id,
          params,
        );
        liveData = data;
      } else {
        return;
      }
      let frame = document.getElementById('frame');
      frame.allow =
        'microphone *;camera *;midi *;encrypted-media *;autoplay *;fullscreen *;display-capture *;';
      document.getElementById('frame').src = liveData.web_url;
    },
    goBackHandle() {
      this.$router.back();
    },
  },
  mounted() {
    if (this.bjy_period_id) {
      window.addEventListener('message', this.onMessgae);
    }
    this.$nextTick(async () => {
      this.play();
    });
  },
  beforeDestroy() {
    if (this.bjy_period_id) {
      window.removeEventListener('message', this.onMessgae);
    }
  },
};
</script>
<style lang="scss" scoped>
.Live {
  iframe {
    width: 100%;
    height: 100vh;
    display: block;
  }
  .goBack {
    position: absolute;
    top: 0;
    padding: 4px 6px;
    color: #666666;
    &:hover {
      color: red;
    }
    &::before {
      content: '';
      display: inline-block;
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      background: #000;
      opacity: 0.1;
      border-radius: 4px;
    }
  }
}
</style>
